import React, { Component, Suspense } from "react";
import $ from "jquery";
import { Link } from "react-router-dom";
import { apiCalling ,apiCallingWithoutToken} from "../apiService";
import { getSiteData } from "../layout/getSiteDetails";
import bolgtemp from "../image/icons/blogging.png";
import { GoArrowUpRight } from "react-icons/go";
import { HiOutlineClock } from "react-icons/hi2";
import { IoEyeOutline } from "react-icons/io5";
import renderHTML from "react-render-html";
import { RiArrowRightSLine } from "react-icons/ri";
import Arrowleft from "../image/ida/Arrow_left_light.png"
import { Helmet } from "react-helmet";
import InnerHTML from "dangerously-set-html-content";
import search from "../image/media/search.png";
import Grid from "../image/ida/grid.png";
import List from "../image/ida/list.png";
import Sortby from "../image/ida/sort-by.png"
import { IoSearchOutline } from "react-icons/io5";
import moment from "moment";
const folderName = window.sessionStorage.getItem("homeName");

const Home = React.lazy(() => import("../" + folderName + "/home"));
const Header = React.lazy(() => import("../" + folderName + "/header"));
const Footer = React.lazy(() => import("../" + folderName + "/footer"));

export default class HealthblogPost extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectCategotyList: [],
      resultData: [],
      showMessage: [],
    };
  }

  componentDidMount() {
    if (folderName === null) {
      window.sessionStorage.setItem("pathname", window.location.pathname);
      window.location.href = "/";
    }
    this.categorySelectList();

    if (this.props.match.params.categoryId !== "0") {
      this.categorySearchByID(this.props.match.params.categoryId);
    } else {
      this.loadBlogs();
    }
  }
  //! get HealthInfo comman data
  categorySelectList() {
    $(".loader").show();
    const saveField = {
      method: "POST",
      body: JSON.stringify({
        functionName: "getHealthInfoCommonData",
        siteId: window.sessionStorage.getItem("siteId"),
      }),
    };
    // console.log(saveField.body);
    apiCallingWithoutToken(saveField).then((data) => {
      $(".loader").hide();
      if (data.success == "1") {
        this.setState({
          selectCategotyList: data.result,
        });
      }
    });
  }
  loadBlogs() {
    const dataList = {
      method: "POST",
      body: JSON.stringify({
        functionName: "getDoctorHealthArticles",
        siteId: window.sessionStorage.getItem("siteId"),
        categoryId: "",
      }),
    };
    $(".loader").show();
    apiCallingWithoutToken(dataList).then((data) => {
      $(".loader").hide();
      if (data.success == "1" && data.result.length > 0) {
        this.setState({ resultData: data.result });
      } else if (data.success == "0") {
        this.setState({ showMessage: data.errorMessage });
      }
    });
  }
  categorySearch(obj) {
    const dataList = {
      method: "POST",
      body: JSON.stringify({
        functionName: "getDoctorHealthArticles",
        siteId: window.sessionStorage.getItem("siteId"),
        categoryId: obj.categoryId,
      }),
    };
    $(".loader").show();
    // console.log(dataList.body);
    apiCallingWithoutToken(dataList).then((data) => {
      $(".loader").hide();
      if (data.success == "1" && data.result.length > 0) {
        this.setState({ resultData: data.result });
      } else if (data.success == "0") {
        this.setState({ resultData: [] });
        this.setState({ showMessage: data.errorMessage });
      }
    });
    $(".category-sub").removeClass("category-sub-active");
    $("#healthBlogListId" + obj.categoryId).addClass("category-sub-active");
    // $("html,body").animate({"scrollTop": $("#blog-detailsId").offset().top})
  }
  categorySearchByID(id) {
    const dataList = {
      method: "POST",
      body: JSON.stringify({
        functionName: "getDoctorHealthArticles",
        siteId: window.sessionStorage.getItem("siteId"),
        categoryId: id,
      }),
    };
    $(".loader").show();
    apiCallingWithoutToken(dataList).then((data) => {
      $(".loader").hide();
      if (data.success == "1" && data.result.length > 0) {
        this.setState({ resultData: data.result });
      } else if (data.success == "0") {
        this.setState({ resultData: [] });
        this.setState({ showMessage: data.errorMessage });
      }
    });
  }
  blogCategoryList() {
    $(".category-list").toggleClass("category-list-active");
  }
  srcTypeImage(ev) {
    ev.target.src = bolgtemp;
  }

  render() {
    const urlPath = window.location.origin.toString();
    return (
      <div className="pamba-wrapper">
        <Suspense fallback={<div></div>}>
          <section>
            <Header />
          </section>
        </Suspense>
        <Helmet>
          <title>
            {"HealthInfo | " + window.sessionStorage.getItem("siteName") ===
            null
              ? ""
              : window.sessionStorage.getItem("siteName")}
          </title>
          <meta
            name="description"
            content={
              "HealthInfo | " + window.sessionStorage.getItem("siteName") ===
              null
                ? ""
                : window.sessionStorage.getItem("siteName")
            }
          />
        </Helmet>
        <div className="telehealthfeaturehead text-md-left">
          <div className="breadcrumb-main mb-1">
            <ul className="bread-crumb-ul">
              <li className="breadcrumb-light">Home</li>
              <li>
                <RiArrowRightSLine />
              </li>
              <li>Blog</li>
            </ul>

          </div>
          <span>
            <img src={Arrowleft} alt="arrowleft" className="img-fluid mr-2 cursor-pointer"/>
          </span>
          Blog {this.state.resultData.length > 0 ? `(${this.state.resultData.length})` : ""}
        </div>
        <div className="drListMain">
          <div className="container blog-wrapper">
            <div className="row mt-1">
              {this.state.resultData.length > 0 ? (
                <div className="col-md-12" id="blog-detailsId">
                  {/* <div className="filter-search-wrapper">
                    <div className="drSearch">
                      <img
                        alt=""
                        src={search}
                        width="16"
                        style={{ opacity: "0.5" }}
                      ></img>
                      <input
                        type="text"
                        className="drSearchBox"
                        placeholder="Search blog"
                      ></input>


                    </div>
                    <div className="view-listing">
                      <img src={Grid} alt="Grid" className="img-fluid mr-3" />
                      <img src={List} alt="List" className="img-fluid" />
                    </div>
                    <div className="view-listing">
                      <img src={Sortby} alt="Sortby" className="img-fluid" />
                      <span className="ml-1 sortby">Sort By</span>
                    </div>
                  </div> */}
                  <div className="row mt-1 mt-md-0">
                    {this.state.resultData.map((data) => {
                      var slug = data.slug;
                      slug = slug
                        .replace(/\s+/g, "-")
                        .replace("/", "-")
                        .replace("|", "-");
                      slug = slug.replace("--", "-").replace("---", "-");
                      return (
                        <div className="blog-listbox">
                          <div className="blog-listImgDiv">
                            <img
                              onError={this.srcTypeImage}
                              src={data.imageName}
                              alt="Blog Image Name"
                              className="img-fluid blog-listImg"
                            ></img>
                          </div>
                          <div className="blog-list-detils">
                            <div className="blogtag-name">
                              {data.healthInfoTitle}
                            </div>
                            <div className="bloguserList-text bloguserList-text-custom">
                              {data.shortDescription?<InnerHTML html={data.shortDescription} />:""}
                              {/* {data.shortDescription}{" "} */}
                            </div>
                            <div className="d-flex bloguserList-text-info mt-2 mb-4">
                              {/* <span className="bloguserList-text-info-span">
                                <IoEyeOutline size={18} className="text-dark"/> 1.2k
                              </span> */}
                              <span className="bloguserList-text-info-span">
                                <HiOutlineClock size={18} className="text-dark"/>
                                {moment(data.healthInfoPostDate, "DD-MMM-YYYY").format("MMM DD, YY")}
                              </span>
                            </div>
                            {/* <div className="blogtag-main">
                            <div className="blogtag-sub"> Remote work</div>
                            <div className="blogtag-sub"> Webinar</div>
                          </div> */}
                            <Link
                              to={"/HealthBlog/" + data.healthInfoId + "/" + slug}
                              className="readmoreBlog"
                            >
                              View more
                              <GoArrowUpRight size={14} className="ms-2"/>
                            </Link>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              ) : (
                <div
                  className="col-lg-12 col-md-12 py-5"
                  id="blog-detailsId"
                  style={{ textAlign: "center" }}
                >
                  <p className="error-msg text-center mb-0">
                    {" "}
                    {this.state.showMessage}{" "}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
        <Suspense fallback={<div></div>}>
          <section>
            <Footer />
          </section>
        </Suspense>
      </div>
    );
  }
}
